import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/invitation/resend/many/invitation.resend.many.mutation.gql"
import type {
  InvitationResendManyMutation,
  InvitationResendManyMutationVariables,
} from "@/v2-backoffice-client/invitation/resend/many/__types__/invitation.resend.many.mutation"

type Options = MutationHookOptions<
  InvitationResendManyMutation,
  InvitationResendManyMutationVariables
>

export function useInvitationResendManyMutation(options?: Options) {
  return useMutation<
    InvitationResendManyMutation,
    InvitationResendManyMutationVariables
  >(mutation, options)
}
